const license = {
    not_installed: '이 인스턴스에는 라이선스가 설치되어 있지 않습니다.',
    invalid_key: '라이선스 키가 유효하지 않거나 변조되었습니다.',
    expired_key: '라이선스 키가 만료되었습니다. 새 키를 받아 다시 설치해 주세요.',
};
export default Object.freeze(license);
